import { useLazyQuery, useQuery } from "@apollo/client";
import { STOCK_UNITS } from "../stock-unit.queries";
import {
  StockUnitsQuery,
  StockUnitsQueryVariables,
} from "../../../__generated__/StockUnitsQuery";

export const useStockUnits = (variables: StockUnitsQueryVariables) => {
  return useQuery<StockUnitsQuery, StockUnitsQueryVariables>(STOCK_UNITS, {
    variables,
  });
};

export const useLazyStockUnits = () => {
  return useLazyQuery<StockUnitsQuery, StockUnitsQueryVariables>(STOCK_UNITS);
};
